// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// import our own default styles. these can be overidden when required.
import '../../styles/components/carousel.css';

Swiper.use([Autoplay]);
const defaultOptions = {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
};

/**
 *
 * @param {Node} el The carousel wrapper element
 * @param {*} [options] The options object
 * @param {'horizontal' | 'vertical'} [options.direction=horizontal] The carousel direction
 * @param {boolean} [options.loop=true] To loop to start or not.
 * @param {number} [options.slidesPerView=1] Number of slides in view
 * @param {boolean} [options.centeredSlides=true] Center the slides or not
 * @param {any} [options.any] Pass any additional options
 * @param {boolean} [cornerNav] To give the swiper arrows styling in the upper right
 * @returns {null | swiper} Null or the initialized carousel
 *
 */
export default function carousel(el, options = {}, cornerNav = false) {
  if (!el) return null;

  if (cornerNav) {
    el.classList.add('corner-nav');
  }

  const opts = { ...defaultOptions, ...options };
  const swiper = new Swiper(el, {
    ...opts,
    modules: [Navigation, Pagination],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  return swiper;
}
